import React from 'react';
import SubHeader from '../../../common/subHeader';
import Divider from '../../../common/divider';

const DisputeModalComments = (props) => {
    return (
        <div>
            <Divider />
            <SubHeader title="Comments" />
            <Divider />
            <div className="dispute-comments">
                    <label>Comment:</label>
                    <br/>
                    <textarea maxLength="250" id="disputeComment" value={props.comment} size="" onChange={props.onCommentChangeHandler} placeholder="Add comment here"/>
            </div>
        </div>
    );
};

export default DisputeModalComments;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModalComments.js